import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router";
import { updateCurrentPostRegisterPage } from "../../../../../store/actions/admin/create-event";
import { useTypedSelector } from "../../../../../store/reducers/use-typed-selector";
import { IHomepageMainNavItems, NavMainItems } from "../../../../../types/working-model";
import { PATHNAMES } from "../../../../../utils/admin-routing-utils";
import { ParamsProps } from "../../../../live-event/live-event";
import PostRegisterEditorMain from "./post-register-editor-main";

interface IHomeProps {
	navItem: IHomepageMainNavItems | undefined;
	eventMainNavItems: IHomepageMainNavItems[];
}

const Home = React.forwardRef<HTMLDivElement, IHomeProps>(({ navItem }, ref) => {

	const post_register_home_modules = useTypedSelector(state => state.CreateEventReducer.workingEvent?.homepage?.post_register_home_modules);
	const workingEvent = useTypedSelector(state => state.CreateEventReducer.workingEvent);

	const dispatch = useDispatch();
	const history = useHistory();
	const { language } = useParams<ParamsProps>();

	useEffect(() => {
		// if landing on this page from /home, add language
		if (!language && workingEvent) {
			history.replace(PATHNAMES.Event[NavMainItems.Home](workingEvent?.uuid, language ?? workingEvent?.sessions[0].default_language));
		}
		// set currentPage as homepage and reset it when the component is unmounted
		dispatch(updateCurrentPostRegisterPage(NavMainItems.Home));
		return () => {
			dispatch(updateCurrentPostRegisterPage(null));
		};
	}, [dispatch, history, language, workingEvent]);

	if (!navItem?.is_on) return null;

	if (!post_register_home_modules) return null;

	return <PostRegisterEditorMain
		ref={ref}
		pageModuleList={post_register_home_modules}
		isHomePage={true}
	/>;
});

Home.displayName = "Home";

export default Home;
